import i18n from "../../../../constants/i18n";
import { AUDITOR_EVENTS_DATA_HEADERS } from "../../../../constants/table-custom-headers/Auditor";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import Et3Table from "../../../../core/et3-table";
import getAuditorsEventsStore from "../../../../stores/auditor-store/auditors-events-store";

const AuditorsEventsData = withLiteObserverAndTheme(() => {
  const eventsData = getAuditorsEventsStore().auditorEventsData.get();
  return (
    <Et3Table
      columns={AUDITOR_EVENTS_DATA_HEADERS}
      rows={eventsData}
      title={i18n.get("AUDITORS_EFFICIENCY")}
      shouldBeFlagged={false}
      titleKey={"AUDITORS_EFFICIENCY"}
    />
  );
});
export default AuditorsEventsData;
